"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _chip = _interopRequireDefault(require("../../../Chip/chip"));

var _styler = _interopRequireDefault(require("../../../Styler/styler"));

var _airbnbPropTypes = require("airbnb-prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CharacterCounter = function CharacterCounter(_ref) {
  var charsLeft = _ref.charsLeft,
      maxLength = _ref.maxLength;
  return _react.default.createElement(TertiaryFieldLabel, null, _react.default.createElement(_chip.default, {
    danger: charsLeft === 0
  }, "".concat(maxLength - charsLeft, "/").concat(maxLength)));
};

var SecondaryFieldLabel = function SecondaryFieldLabel(_ref2) {
  var children = _ref2.children;
  return _react.default.createElement("span", {
    className: "co-form__label--secondary"
  }, children);
};

var TertiaryFieldLabel = function TertiaryFieldLabel(_ref3) {
  var children = _ref3.children;
  return _react.default.createElement("span", {
    className: "co-form__label--tertiary"
  }, children);
};

var FieldLabel = function FieldLabel(_ref4) {
  var htmlFor = _ref4.htmlFor,
      children = _ref4.children,
      required = _ref4.required,
      secondaryLabel = _ref4.secondaryLabel,
      tertiaryLabel = _ref4.tertiaryLabel,
      charsLeft = _ref4.charsLeft,
      maxLength = _ref4.maxLength,
      error = _ref4.error,
      warning = _ref4.warning,
      disabled = _ref4.disabled,
      small = _ref4.small,
      large = _ref4.large,
      props = _objectWithoutProperties(_ref4, ["htmlFor", "children", "required", "secondaryLabel", "tertiaryLabel", "charsLeft", "maxLength", "error", "warning", "disabled", "small", "large"]);

  var allowedModifiers = {
    error: error,
    warning: warning,
    small: small,
    large: large,
    disabled: disabled
  };
  return _react.default.createElement(_styler.default, {
    className: 'co-label',
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("label", {
      className: styles,
      htmlFor: htmlFor
    }, children, required ? _react.default.createElement("abbr", {
      className: "co--required",
      title: "Required"
    }, "*") : null, secondaryLabel ? _react.default.createElement(SecondaryFieldLabel, null, secondaryLabel) : null, tertiaryLabel && charsLeft === undefined ? _react.default.createElement(TertiaryFieldLabel, null, tertiaryLabel) : null, charsLeft >= 0 ? _react.default.createElement(CharacterCounter, {
      charsLeft: charsLeft,
      maxLength: maxLength
    }) : null);
  });
};

var exclusiveSizes = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('small', 'large');
var exclusiveStates = (0, _airbnbPropTypes.mutuallyExclusiveTrueProps)('error', 'warning');
FieldLabel.propTypes = {
  htmlFor: _propTypes.string,

  /** {string} */
  children: _propTypes.any,
  required: _propTypes.bool,
  secondaryLabel: _propTypes.string,

  /** {string} Mutually exclusive props: @@tertiaryLabel@@ @@charsLeft@@ */
  tertiaryLabel: _propTypes.string,

  /** {number} Mutually exclusive props: @@tertiaryLabel@@ @@charsLeft@@ */
  charsLeft: _propTypes.number,
  maxLength: _propTypes.number,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  small: exclusiveSizes,

  /** {bool} Mutually exclusive props: @@small@@ @@large@@ */
  large: exclusiveSizes,

  /** {bool} Multually exclusive props: @@error@@ @@warning@@ */
  error: exclusiveStates,

  /** {bool} Multually exclusive props: @@error@@ @@warning@@ */
  warning: exclusiveStates,
  disabled: _propTypes.bool
};
FieldLabel.displayName = 'Form.Label';
var _default = FieldLabel;
exports.default = _default;
FieldLabel.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Form.Label",
  "props": {
    "htmlFor": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "{string}"
    },
    "required": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "secondaryLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "tertiaryLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "{string} Mutually exclusive props: @@tertiaryLabel@@ @@charsLeft@@"
    },
    "charsLeft": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "{number} Mutually exclusive props: @@tertiaryLabel@@ @@charsLeft@@"
    },
    "maxLength": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "small": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "large": {
      "type": {
        "name": "custom",
        "raw": "exclusiveSizes"
      },
      "required": false,
      "description": "{bool} Mutually exclusive props: @@small@@ @@large@@"
    },
    "error": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStates"
      },
      "required": false,
      "description": "{bool} Multually exclusive props: @@error@@ @@warning@@"
    },
    "warning": {
      "type": {
        "name": "custom",
        "raw": "exclusiveStates"
      },
      "required": false,
      "description": "{bool} Multually exclusive props: @@error@@ @@warning@@"
    },
    "disabled": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    }
  }
};